export default __webpack_public_path__ + "static/media/avater6.f73be852.png";